import PropTypes from 'prop-types';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Confirm} from 'semantic-ui-react';

import {addSuccessMessage} from 'state/actions';

const RemoveProjectModal = ({trigger, projectName, onConfirm, content}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <Confirm
      trigger={trigger}
      onConfirm={async () => {
        setIsDeleting(true);
        try {
          await onConfirm();
          setDeleteModalOpen(false);
          dispatch(addSuccessMessage(`The site ${projectName} was deleted successfully`));
          history.push('/my-sites');
        } finally {
          setIsDeleting(false);
        }
        setDeleteModalOpen(false);
        history.push('/my-sites');
      }}
      onOpen={() => setDeleteModalOpen(true)}
      onCancel={() => setDeleteModalOpen(false)}
      header="Confirmation required"
      content={{content}}
      open={deleteModalOpen}
      confirmButton={{
        negative: true,
        content: 'Delete',
        disabled: isDeleting,
        loading: isDeleting,
      }}
      cancelButton={{content: 'Cancel', disabled: isDeleting, loading: isDeleting}}
      closeOnDimmerClick={!isDeleting}
      closeOnDocumentClick={!isDeleting}
    />
  );
};

RemoveProjectModal.propTypes = {
  trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  projectName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  content: PropTypes.node.isRequired,
};

export default RemoveProjectModal;
